import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import {
  AddArticleAction,
  ARTICLE_TYPES,
  EditArticleAction,
  DeleteArticleAction,
  GetAllArticlesAction,
  GetOneArticleAction,
} from './articleTypes';
import * as Actions from './articleActions';
import * as CategoryActions from '../../category/redux/categoryActions';
import { ArticleApi } from '../api/articleApi';
import { ArticleGetResponse } from '../model/articleModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';
import { CategoryGetResponse } from '../../category/model/categoryModel';
import { CategoryApi } from '../../category/api/categoryApi';

function* addArticleSaga(add: AddArticleAction) {
  try {
    const articleToPost = {
      ...add.payload.article,
      isPublished: add.payload.article.isPublished === 'true',
      isNotificationNeeded: add.payload.article.isNotificationNeeded === 'true',
    };

    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<ArticleGetResponse> = yield call(ArticleApi.post, articleToPost);

    yield put(Actions.getOneArticleSuccess(response.data));
    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.SUCCEEDED_ADD));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiArticleRequestError(error.response.data.detail));
    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* editArticleSaga(edit: EditArticleAction) {
  try {
    let articleToPut = {
      ...edit.payload.article,
      isPublished: edit.payload.article.isPublished === 'true',
      isNotificationNeeded: edit.payload.article.isNotificationNeeded === 'true',
    };

    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.LOADING));

    yield call(ArticleApi.put, edit.payload.params, articleToPut);

    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.SUCCEEDED_EDIT));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiArticleRequestError(error.response.data.detail));
    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* deleteArticleSaga(edit: DeleteArticleAction) {
  try {
    let articleDeleteAt = {
      deleteAt: new Date(),
    };

    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.LOADING));

    yield call(ArticleApi.delete, edit.payload.params, articleDeleteAt);

    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.SUCCEEDED_DELETE));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiArticleRequestError(error.response.data.detail));
    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getOneArticleSaga(getOne: GetOneArticleAction) {
  try {
    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<ArticleGetResponse> = yield call(ArticleApi.getOne, getOne.payload.params);
    const categoryTree: AxiosResponse<CategoryGetResponse[]> = yield call(CategoryApi.getCategoriesTree, {
      id: response.data.category.id as unknown as string,
    });

    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.SUCCEEDED_GET));
    yield put(Actions.getOneArticleSuccess(response.data));
    yield put(CategoryActions.getCategoriesTreeSuccess(categoryTree.data));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiArticleRequestError(error.response.data.detail));
    yield put(Actions.setApiArticleRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getAllArticlesSaga(getAll: GetAllArticlesAction) {
  try {
    yield put(Actions.setApiArticlesRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<ArticleGetResponse[]> = yield call(ArticleApi.getAll, getAll.payload.articleFilter);

    yield put(Actions.setApiArticlesRequestState(API_REQUEST_STATE.SUCCEEDED_GET));
    yield put(Actions.getAllArticlesSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiArticlesRequestError(error.response.data.detail));
    yield put(Actions.setApiArticlesRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

export default function* watch() {
  yield* [
    takeLatest(ARTICLE_TYPES.ADD, addArticleSaga),
    takeLatest(ARTICLE_TYPES.EDIT, editArticleSaga),
    takeLatest(ARTICLE_TYPES.DELETE, deleteArticleSaga),
    takeLatest(ARTICLE_TYPES.GET_ONE, getOneArticleSaga),
    takeLatest(ARTICLE_TYPES.GET_ALL, getAllArticlesSaga),
  ];
}
